export const composeFormData = (
  jsonData: Record<string, (string | File[]) | string[] | undefined>
): FormData => {
  const formData = new FormData();

  const handleListOfValues = (
    key: string,
    values: Array<string | File | undefined>
  ) => {
    values.forEach((value) => {
      if (value) {
        formData.append(key, value);
      }
    });
  };

  // Parse input and append to form data
  Object.keys(jsonData).forEach((key) => {
    const value = jsonData[key];
    if (!value) {
      return;
    }
    if (Array.isArray(value)) {
      handleListOfValues(key, value);
      return;
    }
    if (typeof value === "object") {
      formData.append(key, JSON.stringify(value));
      return;
    }
    formData.append(key, value);
  });

  return formData;
};
